export const VariablesType = [
  { label: "Число", value: "number" },
  { label: "Строка", value: "string" },
  { label: "Дата", value: "date" },
  { label: "Телефон", value: "phone" },
  { label: "Email", value: "mail" },
  { label: "Ссылка", value: "link" },
  { label: "Время", value: "time" },
];
